/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiResponse } from '@squiz/dxp-ai-client';
import React from 'react';
import { VerticalDivider } from '../../VerticalDivider/VerticalDivider';
import { AiStatusBadge } from '../../AiStatusBadge/AiStatusBadge';
import { AiFlaggedInteractions } from '../../AiFlaggedInteractions/AiFlaggedInteractions';

/**
 * Creates the enabled or disabled footer for the Ai data list component.
 * @export
 * @param {AiResponse} ai
 * @return {*}  {React.JSX.Element}
 */
export function createAiListFooter(ai: AiResponse): React.JSX.Element {
  return (
    <div className="ai-data-list-item-footer">
      <AiStatusBadge ai={ai} />
      <VerticalDivider />
      <AiFlaggedInteractions ai={ai} />
    </div>
  );
}
